"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;

var React = require("react");

var MdKeyboardArrowRight_1 = require("@react-icons/all-files/md/MdKeyboardArrowRight");

var MdKeyboardArrowLeft_1 = require("@react-icons/all-files/md/MdKeyboardArrowLeft");

var MdMoreHoriz_1 = require("@react-icons/all-files/md/MdMoreHoriz");

var styled_components_1 = require("styled-components");

var lodash_1 = require("lodash");

var react_responsive_1 = require("react-responsive");

var __1 = require("..");

var theme_1 = require("../../theme");

var utils_1 = require("../../utils");

var PaginationButton = styled_components_1.default(__1.Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var $active = _a.$active,
      _b = _a.$themeStyles,
      activeBorderColor = _b.activeBorderColor,
      borderColor = _b.borderColor,
      activeBackgroundColor = _b.activeBackgroundColor,
      borderHoverColor = _b.borderHoverColor,
      backgroundHoverColor = _b.backgroundHoverColor,
      backgroundColor = _b.backgroundColor,
      borderRadius = _b.borderRadius,
      activeColor = _b.activeColor,
      color = _b.color;
  return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding: 5px;\n      margin: 2px;\n      height: 40px;\n      border-radius: ", "px;\n      width: 40px;\n      border: 1px solid ", ";\n      align-items: center;\n      justify-content: center;\n      display: flex;\n      background-color: ", ";\n      color: ", ";\n      box-shadow: none;\n\n      ", "\n\n      ", "\n\n    transition: all ease 0.3s;\n    "], ["\n      padding: 5px;\n      margin: 2px;\n      height: 40px;\n      border-radius: ", "px;\n      width: 40px;\n      border: 1px solid ", ";\n      align-items: center;\n      justify-content: center;\n      display: flex;\n      background-color: ", ";\n      color: ", ";\n      box-shadow: none;\n\n      ", "\n\n      ", "\n\n    transition: all ease 0.3s;\n    "])), borderRadius, $active ? activeBorderColor : borderColor, $active ? activeBackgroundColor : backgroundColor, $active ? activeColor : color, !$active && "\n      &:hover {\n        border: 1px solid " + borderHoverColor + ";\n        background-color: " + backgroundHoverColor + ";\n      }\n      ", $active && "\n      cursor: default;\n      pointer-events: none;\n      ");
});

function IconButton(_a) {
  var onClick = _a.onClick,
      isNext = _a.isNext;
  var buttonType = isNext ? MdKeyboardArrowRight_1.MdKeyboardArrowRight : MdKeyboardArrowLeft_1.MdKeyboardArrowLeft;
  return React.createElement(__1.Button, {
    style: {
      padding: 0,
      marginTop: 4
    },
    variant: "transparent",
    onClick: onClick,
    leftIcon: buttonType,
    leftIconProps: {
      size: 30
    }
  });
}

var MoreIcon = styled_components_1.default(MdMoreHoriz_1.MdMoreHoriz)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (p) {
  return p.$themeStyles.color;
});

function Pagination(_a) {
  var pageIndex = _a.pageIndex,
      pageCount = _a.pageCount,
      _b = _a.maxPageCount,
      maxPageCount = _b === void 0 ? 7 : _b,
      onChange = _a.onChange,
      _c = _a.variant,
      variant = _c === void 0 ? 'default' : _c;
  var theme = styled_components_1.useTheme();
  var isMobile = react_responsive_1.useMediaQuery({
    maxWidth: theme_1.default.breakpoints.sm
  });
  var maxPagesToDisplay = isMobile ? 5 : maxPageCount;
  var halfOfMaxPages = (maxPagesToDisplay - 1) / 2;
  var buttonsBeginning = pageIndex + 1 - halfOfMaxPages;
  buttonsBeginning = buttonsBeginning < 0 ? 0 : buttonsBeginning;
  var buttonsEnd = pageIndex + 1 + halfOfMaxPages - 1;
  buttonsEnd = buttonsEnd >= pageCount ? pageCount : buttonsEnd;
  var array = Array.from(Array(pageCount).keys());

  if (buttonsBeginning === 0) {
    var gap = maxPagesToDisplay - buttonsEnd - 1;
    buttonsEnd = buttonsEnd + gap;
  }

  if (buttonsEnd === pageCount) {
    var gap = maxPagesToDisplay - (pageCount - buttonsBeginning) - 1;
    buttonsBeginning = buttonsBeginning - gap;
  }

  var currentButtons = array.slice(buttonsBeginning, buttonsEnd);
  var showFirstButton = buttonsBeginning > 0;
  var showLastButton = buttonsEnd < pageCount;
  var showPreviousPage = pageIndex + 1 > 1;
  var showNextPage = pageIndex + 1 < pageCount;

  var handleChange = function handleChange(page) {
    if (lodash_1.isFunction(onChange)) {
      onChange(page);
    }
  };

  var paginationDisplay = pageCount <= 1 || !pageCount ? 'none' : 'flex';
  var themeStyles = utils_1.getComponentThemeStyles(theme, 'Pagination', variant, null);
  return React.createElement(__1.Block, {
    display: paginationDisplay,
    alignItems: "center",
    mt: 2,
    mb: 5,
    justifyContent: "center"
  }, React.createElement(React.Fragment, null, showPreviousPage && React.createElement(IconButton, {
    "aria-label": "Previous Page",
    onClick: function onClick() {
      handleChange(pageIndex - 1);
    }
  }), showFirstButton && React.createElement(React.Fragment, null, React.createElement(PaginationButton, {
    variant: variant,
    "aria-label": "Page 1",
    onClick: function onClick() {
      handleChange(0);
    },
    "$active": pageIndex === 0,
    "$themeStyles": themeStyles
  }, "1"), pageIndex > 3 && React.createElement(MoreIcon, {
    size: 30,
    "$themeStyles": themeStyles
  })), currentButtons.map(function (k) {
    var pageNumber = k + 1;
    return React.createElement(PaginationButton, {
      variant: variant,
      key: "Page " + pageNumber,
      "aria-label": "Page " + pageNumber,
      "$active": pageIndex === k,
      onClick: function onClick() {
        handleChange(k);
      },
      "$themeStyles": themeStyles
    }, pageNumber);
  }), showLastButton && React.createElement(React.Fragment, null, pageIndex < pageCount - 2 && React.createElement(MoreIcon, {
    size: 30,
    "$themeStyles": themeStyles
  }), React.createElement(PaginationButton, {
    variant: variant,
    "aria-label": "Last Page",
    onClick: function onClick() {
      handleChange(pageCount - 1);
    },
    "$active": pageIndex === pageCount - 1,
    "$themeStyles": themeStyles
  }, pageCount)), showNextPage && React.createElement(IconButton, {
    "aria-label": "Next Page",
    isNext: true,
    onClick: function onClick() {
      handleChange(pageIndex + 1);
    }
  })));
}

exports.Pagination = Pagination;
var templateObject_1, templateObject_2, templateObject_3;